import {CustomText, H6Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import MaintenanceIcon from '@buncha/components/core/icon/MaintenanceIcon';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import React, {useMemo} from 'react';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import UnTrustedIcon from '@buncha/components/core/icon/UntrustedIcon';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {useGetLocale} from '@buncha/localization/hooks';

type Props = NativeStackScreenProps<any, any>;

const DownTime: React.FC<Props> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const unTrusted = props?.route?.params?.unTrusted;
  const {body} = useGetLocale(Modules.maintenance, MainScreens.DownTime) ?? {};
  const downTimeIcon = useMemo(() => {
    if (unTrusted)
      return (
        <UnTrustedIcon
          fill={theme?.text?.blue?.[300]}
          height={128}
          width={128}
          viewBox="0 0 512 512"
        />
      );

    return (
      <MaintenanceIcon
        fill={theme?.text?.blue?.[300]}
        height={128}
        width={128}
        viewBox="-1 -2 128 132"
      />
    );
  }, [theme?.text, unTrusted]);

  const getTextAndImage = useMemo(() => {
    if (unTrusted)
      return {
        title: body?.notAvailable,
        subTitle: body?.badDevice,
        icon: downTimeIcon,
      };
    return {
      title: body?.underMaintenance,
      subTitle: body?.underMaintenanceText,
      icon: downTimeIcon,
    };
  }, [
    body?.badDevice,
    body?.notAvailable,
    body?.underMaintenance,
    body?.underMaintenanceText,
    downTimeIcon,
    unTrusted,
  ]);
  return (
    <Box style={styles.parentBox}>
      {getTextAndImage.icon}
      <Box>
        <H6Text
          style={{
            color: theme?.text?.blue?.[300],
            fontFamily: muli?.[700]?.normal,
          }}>
          {getTextAndImage.title}
        </H6Text>
        <CustomText
          style={{
            color: theme?.text?.gray?.[100],
            fontFamily: muli?.[600]?.normal,
          }}>
          {getTextAndImage.subTitle}
        </CustomText>
      </Box>
    </Box>
  );
};

export default React.memo(DownTime);

export const styles = StyleSheet.create({
  parentBox: {
    flex: 1,
    justifyContent: 'center',
    padding: 20,
    gap: scaleFonts(15),
    alignItems: 'center',
  },
});
